import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';

interface WatchTutorialsButtonProps {
  partnerName: string;
  onClick: () => void;
}

const WatchTutorialsButton = ({ partnerName, onClick }: WatchTutorialsButtonProps) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className={styles.watchTutorials}
      onClick={onClick}
      aria-label={t('videoTutorials.watchTutorialsLabel', { partnerName })}
    >
      <i className="totem-icon totem-icon-play" aria-hidden="true" />
      {t('videoTutorials.watchTutorials')}
    </button>
  );
};

export default WatchTutorialsButton;
